import { useState } from "react";

import ViewContainer from "../../../../components/layout/view/ViewContainer";
import ContentPanel from "../../../../components/layout/content/ContentPanel";
import ContentPanelHeader from "../../../../components/layout/content/ContentPanelHeader";
import SecondaryPillTabs from "../../../../components/tabs/SecondaryPillTabs";

import { CreatorAccessSection } from "../components/CreatorAccessSection.jsx";

import { useCreatorVideoAccess } from "../hooks/useCreatorVideoAccess.js";
import { useCreatorAlbumAccess } from "../hooks/useCreatorAlbumAccess";
import { useCreatorStreamAccess } from "../hooks/useCreatorStreamAccess";
import { useCreatorPopAccess } from "../hooks/useCreatorPopAccess";

const TAB_CONFIG = {
  video: {
    label: "Videos",
    itemSingular: "video",
    itemIdKey: "videoId",
    grantIdsKey: "videoIds",
  },
  album: {
    label: "Albums",
    itemSingular: "album",
    itemIdKey: "albumId",
    grantIdsKey: "albumIds",
  },
  stream: {
    label: "Streams",
    itemSingular: "stream",
    itemIdKey: "streamSessionId",
    grantIdsKey: "streamSessionIds",
  },
  pop: {
    label: "Pops",
    itemSingular: "Pop",
    itemIdKey: "popId",
    grantIdsKey: "popIds",
  },
};

function VideoAccess({ username, userId }) {
  const resource = useCreatorVideoAccess(username, userId);

  return <CreatorAccessSection resource={resource} config={TAB_CONFIG.video} />;
}

function AlbumAccess({ username, userId }) {
  const resource = useCreatorAlbumAccess(username, userId);

  return <CreatorAccessSection resource={resource} config={TAB_CONFIG.album} />;
}

function StreamAccess({ username, userId }) {
  const resource = useCreatorStreamAccess(username, userId);

  return (
    <CreatorAccessSection resource={resource} config={TAB_CONFIG.stream} />
  );
}

function PopAccess({ username, userId }) {
  const resource = useCreatorPopAccess(username, userId);

  return <CreatorAccessSection resource={resource} config={TAB_CONFIG.pop} />;
}

const TABS = [
  { id: "video", label: "Videos", Component: VideoAccess },
  { id: "album", label: "Albums", Component: AlbumAccess },
  { id: "stream", label: "Streams", Component: StreamAccess },
  { id: "pop", label: "Pops", Component: PopAccess },
];

export default function CreatorFreeAccessView({ username, userId }) {
  const [activeTab, setActiveTab] = useState("video");

  const selected = TABS.find((item) => item.id === activeTab) || TABS[0];

  const Section = selected.Component;

  const handleTabChange = (value) => {
    const tab = typeof value === "string" ? value : value?.id || value?.value;

    if (TABS.some((item) => item.id === tab)) {
      setActiveTab(tab);
    }
  };

  return (
    <ViewContainer>
      <ContentPanel>
        <ContentPanelHeader
          title="Content Access"
          subTitle="Manage who can access your content."
        />

        <SecondaryPillTabs
          tabs={TABS.map(({ id, label }) => ({ id, label }))}
          activeTab={activeTab}
          onChange={handleTabChange}
        />

        <Section
          key={`${activeTab}:${username}:${userId}`}
          username={username}
          userId={userId}
        />
      </ContentPanel>
    </ViewContainer>
  );
}
